var _tspan;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAscensor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 125.49 129.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 125.49,
    height: 129.11,
    style: {
      fill: "#5d6163"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.93,
    y: 22.98,
    width: 81.6,
    height: 106.13,
    style: {
      fill: "#333e48"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.4,
    y: 26.34,
    width: 74.76,
    height: 102.77,
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.73,
    y: 26.34,
    width: 2.03,
    height: 102.77,
    style: {
      fill: "#5c6672"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.59,
    y: 3.72,
    width: 22.19,
    height: 15.66,
    style: {
      fill: "#333e48"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.39,
    y: 62.18,
    width: 13.37,
    height: 28.16,
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(58.78 17.13)",
    style: {
      fill: "#fff",
      fontFamily: "MyriadPro-Regular, &apos",
      fontSize: "15.37px"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "114.08 68.2 110.54 74.34 117.62 74.34 114.08 68.2",
    style: {
      fill: "#90bf33"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.08 84.17 117.62 78.04 110.54 78.04 114.08 84.17",
    style: {
      fill: "#c03233"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscensor);
export default __webpack_public_path__ + "static/media/ascensor.bdf22196b853c666484ca296dba42985.svg";
export { ForwardRef as ReactComponent };